import {RefObject} from "react";
import {SIGNAL_DETAIL_ROUTE} from "../constants/routes";
import Papa from 'papaparse';
import dayjs from "dayjs";

/**
 * Transforms CSV data exported from the SignalViewComponent
 * before generating the final CSV output.
 */
export const transformSignalViewCsvData = (data: string, signalViewRef: RefObject<any>): string => {
  const csvParse: any = Papa.parse(data, {
    skipEmptyLines: true,
    header: true,
  });

  let {data: parsedData} = csvParse;
  parsedData = parsedData.map((row: {
    [key: string]: any
  }) => {
    const {
      'Catégorie': requestType,
      'Pièce-jointe (Oui/Non)': hasAttachments,
      'Lien du signalement': signalId,
      'Date de création': createdAt
    } = row;

    return {
      ...row,
      'Catégorie': signalViewRef?.current.getSignalCategory(requestType)?.label,
      'Date de création': dayjs(createdAt).format('DD/MM/YYYY HH:mm:ss'),
      'Lien du signalement': `${window.location.origin}${SIGNAL_DETAIL_ROUTE.replace(':id', signalId)}`,
      'Pièce-jointe (Oui/Non)': hasAttachments ? 'Oui' : 'Non',
    };
  });

  return Papa.unparse(parsedData);
};
